import { render, staticRenderFns } from "./CheckTheGoodsWindow.vue?vue&type=template&id=2d7d6400&"
import script from "./CheckTheGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./CheckTheGoodsWindow.vue?vue&type=script&lang=js&"
import style0 from "./CheckTheGoodsWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7d6400')) {
      api.createRecord('2d7d6400', component.options)
    } else {
      api.reload('2d7d6400', component.options)
    }
    module.hot.accept("./CheckTheGoodsWindow.vue?vue&type=template&id=2d7d6400&", function () {
      api.rerender('2d7d6400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/booking/CheckTheGoodsWindow.vue"
export default component.exports